import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/createClass/createClass.vue'
import Course from '../views/course/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '2023届大学新生课表统一查询入口', keepAlive: false }
  },
  {
    path: '/course',
    name: 'course',
    component: Course,
    meta: { title: '2023届大学新生课表统一查询入口', keepAlive: true }
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@/views/result'),
    meta: { title: '超级课程表', keepAlive: true }
  },

]

const router = new VueRouter({
  routes
})

export default router
